import { ChatBubbleLeftRightIcon, InboxIcon } from '@heroicons/react/24/outline';
import { Card, CardBody } from '@heroui/react';
import { motion } from 'framer-motion';

export const NoData = ({
  message = 'NO DATA',
  variant = 'default',
}: {
  message?: string;
  variant?: 'default' | 'chat' | 'empty';
}) => {
  const getIcon = () => {
    if (variant === 'chat') {
      return <ChatBubbleLeftRightIcon className='w-16 h-16 text-gray-300' />;
    }
    if (variant === 'empty') {
      return <InboxIcon className='w-16 h-16 text-gray-300' />;
    }
    return null;
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.2 }}
      className='flex items-center justify-center w-full h-full min-h-[200px]'
    >
      <Card className='border-none shadow-none bg-transparent'>
        <CardBody className='flex flex-col items-center justify-center gap-3 p-8'>
          {getIcon()}
          <p className='text-gray-500 text-sm font-medium text-center'>{message}</p>
        </CardBody>
      </Card>
    </motion.div>
  );
};
